import styled from 'styled-components';
import { devices } from '../../../const/devices';

export const TabTitle = styled.h4`
	font-size: 20px;
	font-weight: 500;
	line-height: 28px;

	color: #262626;
`;

export const EvidenceHeaderContainer = styled.div`
	display: flex;
	flex-flow: row wrap;
	align-items: flex-start;
	padding: 10px 20px 20px;
	margin-bottom: 30px;
	margin-top: 10px;
	background-color: #d9d9d91a;
	gap: 10px;

	& > div {
		flex: 1;

		&:first-of-type,
		&:nth-of-type(2) {
			flex: 1;
			flex-basis: 120px;
		}

		&:last-of-type {
			flex: 3;
		}
	}

	@media ${devices.tablet} {
		background-color: transparent;
		padding: 10px 0 10px;
	}
`;

export const ColumnLabel = styled.div`
	height: 32px;
	display: flex;
	align-items: center;
`;
